export default __webpack_public_path__ + "static/media/tick-circle-active.ff5e14e3.svg";